export const crmCompaniesArticle = {
  title: 'Customer CRM: Companies',
  slug: 'crm-companies',
  content: `Customer CRM: Companies

The Companies tab tracks organizations and links them to people and deals.

1) Navigate to Companies
- From /crm, select the Companies tab ("Companies").
- Use the view switcher to toggle between Table, Kanban, and Gallery views.

2) Search + filters
- Use the search bar to find companies by name.
- Filter to focus on the accounts you need to work on today.

3) Add a company
- Quick Add requires only a company name.
- Use Full Form to add website, industry, size, and notes.

4) View company details
- Open a company record to see related contacts and activity.
- Use company notes to capture account-specific context.
`,
};
